import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createReaction: {
    method: 'POST',
    url: `${configs.baseUrl}/api/reaction/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createReaction = async (payload) => {
  const res = await resource.createReaction(payload)
  return res.body
}

export default {
  initResource,
  createReaction,
}
